import React from 'react';
import PropTypes from 'prop-types';

const Input = (
  {
    input,
    label,
    labelMeta,
    placeholder,
    readOnly,
    type,
    className,
    onKeyPress,
    onKeyUp,
    appendInput,
    prependInput,
    meta: { touched, error, invalid, warning },
  },
  context
) => {
  if (readOnly) input.readOnly = true;
  return (
    <div className="form-group">
      {label && labelMeta && (
        <div className="row">
          <div className="col">
            <label>{label}</label>
          </div>
          <div className="col-auto">{labelMeta}</div>
        </div>
      )}
      {label && !labelMeta && <label>{label}</label>}
      {type === 'textarea' && (
        <textarea
          {...input}
          value={input.value}
          className={`form-control ${className ? className : ''} ${
            prependInput ? 'form-control-prepended' : ''
          } ${appendInput ? 'form-control-appended' : ''} ${
            touched && invalid ? 'is-invalid' : ''
          }`}
          placeholder={placeholder}
          onKeyPress={onKeyPress}
          maxLength="3000"
          onKeyUp={onKeyUp}
        />
      )}
      {(type === 'text' || type === 'number' || type === 'password' || type === 'email') && (
        <div className={appendInput || prependInput ? 'input-group input-group-merge' : ''}>
          <input
            {...input}
            value={input.value}
            className={`form-control ${className ? className : ''} ${
              prependInput ? 'form-control-prepended' : ''
            } ${appendInput ? 'form-control-appended' : ''} ${
              touched && invalid ? 'is-invalid' : ''
            }`}
            step="any"
            placeholder={placeholder}
            onKeyPress={onKeyPress}
            onKeyUp={onKeyUp}
            type={type}
          />
          {prependInput && <div className="input-group-prepend">{prependInput}</div>}
          {appendInput && <div className="input-group-append">{appendInput}</div>}
          <div className="invalid-feedback">
            {' '}
            {touched &&
              ((error && <span>{context.t(error)}</span>) ||
                (warning && <span>{context.t(warning)}</span>))}
          </div>
        </div>
      )}
    </div>
  );
};

Input.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Input;
